import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '@psei/ng/button';
import { IconModule } from '@psei/ng/icon';
import { PipesModule } from '../pipes/pipes.module';
import { PseiNgCustomModule } from '../psei-ng-custom.module';
import { PseicFormFieldModule } from '../pseic-form-field/pseic-form-field.module';
import { AdditionalInformationComponent } from './additional-information/additional-information.component';
import { AddressComponent } from './address/address.component';
import { BusinessAreaComponent } from './business-area/business-area.component';
import { ContactComponent } from './contact/contact.component';
import { CorrespondenceAddressComponent } from './correspondence-address/correspondence-address.component';
import { CountryComponent } from './country/country.component';
import { GeneralInformationComponent } from './general-information-component/general-information.component';
import { IdentificationDataComponent } from './identification-data/identification-data.component';
import { AbpbPermissionsComponent } from './permission-proposal/abpb-permissions/abpb-permissions.component';
import { UserDataComponent } from './permission-proposal/user-data/user-data.component';
import { OperatorCommentsComponent } from './proposal/operator-comments/operator-comments.component';
import {
  ProposalPbGeneralInformationComponent
} from './proposal/proposal-pb-general-information/proposal-pb-general-information.component';
import { PseicSectionComponent } from './pseic-section/pseic-section.component';

@NgModule({
  declarations: [PseicSectionComponent, AdditionalInformationComponent, AddressComponent, BusinessAreaComponent,
    ContactComponent, CorrespondenceAddressComponent, GeneralInformationComponent, IdentificationDataComponent,
    ProposalPbGeneralInformationComponent, OperatorCommentsComponent, UserDataComponent, AbpbPermissionsComponent,
    CountryComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    PseicFormFieldModule,
    IconModule,
    FormsModule,
    PipesModule,
    PseiNgCustomModule,
    ButtonModule,
  ],
  exports: [
    PseicSectionComponent,
    AdditionalInformationComponent,
    AddressComponent,
    BusinessAreaComponent,
    ContactComponent,
    CorrespondenceAddressComponent,
    GeneralInformationComponent,
    IdentificationDataComponent,
    ProposalPbGeneralInformationComponent,
    OperatorCommentsComponent,
    UserDataComponent,
    AbpbPermissionsComponent,
    CountryComponent
  ],
})
export class PseicSectionModule {
}
